<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { ref } from "vue";

interface TabbarItem {
  name: string;
  title: string;
  icon: string;
}

const props = defineProps<{
  items: TabbarItem[];
  active?: string;
  allowSwitch: boolean;
}>();

const emit = defineEmits(["tab-switch", "clickItem"]);

const innerActive = ref(props.active);

function onTabSwitch(item: any) {
  emit("tab-switch", item.name);
}

function beforeSwitch(item: any) {
  emit("clickItem", item.name);
  return props.allowSwitch;
}
</script>
<template>
  <nut-tabbar
    v-bind="$attrs"
    :model-value="innerActive"
    :before-switch="beforeSwitch"
    @tab-switch="onTabSwitch"
  >
    <nut-tabbar-item
      v-for="item in items"
      :key="item.name"
      :name="item.name"
      :tab-title="item.title"
    >
      <template #icon>
        <MpIcon :name="item.icon" />
      </template>
    </nut-tabbar-item>
  </nut-tabbar>
</template>
